export function shareOnFacebook(appURL: string) {
    open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(appURL)}`);
}

export function shareOnTwitter(appURL: string, title: string, showBranding: boolean) {
    let titleRaw = `Check out ${title}!`;
    if (showBranding) {
        titleRaw += ` An app made with @glideapps from a Google Sheet, without writing any code.`;
    }
    const titlecomponent = encodeURIComponent(titleRaw);
    open(`https://twitter.com/intent/tweet?text=${titlecomponent}%20${encodeURIComponent(appURL)}`);
}

export function shareOnTwitterReferral(referral: string) {
    const titleRaw = `Wow. I created an app from a Google Sheet with @glideapps 🙌
    
Use my referral link if you check it out! `;

    const titlecomponent = encodeURIComponent(titleRaw);
    open(`https://twitter.com/intent/tweet?text=${titlecomponent}%20${encodeURIComponent(referral)}`);
}

function open(url: string) {
    const height = 400;
    const width = 600;
    const top = (window.innerHeight - height) / 2;
    const left = (window.innerWidth - width) / 2;

    const options = `location=yes, height=${height}, width=${width}, top=${top}, left=${left}, scrollbars=yes,status=yes`;
    window.open(url, "GLIDE_ShareWindow", options);
}
